import Brand from "@modules/home/brand";
import Carousel from "@modules/home/carousel";
import Categories from "@modules/home/categories";
import Widget from "@modules/home/widget";
import CollectionList from "@modules/home/collectionList";
import { IHomeDataInput } from "@types";
import { useAppContext } from "@context/app";
import { useEffect } from "react";
import VideoList from "@modules/home/videoList";
import dynamic from "next/dynamic";
import HomeDonationBanner from "@modules/donation/HomeDonationBanner";
import MainBanner from "@modules/home/mainBanner";
import HomeDrawers from "@modules/home/drawers";
const ActiveOrder = dynamic(() => import("@modules/home/activeOrder"), { ssr: false });

interface Props {
  data?: IHomeDataInput;
}

const Home: React.FC<Props> = ({ data }) => {
  const { setEventProperties, user, syncData } = useAppContext();

  useEffect(() => {
    setEventProperties({
      from_page: "homepage",
      from_entity: "home",
      from_entity_slug: data?.entity?.slug || "",
      from_page_section: "",
      from_page_section_entity: "",
      from_page_section_slug: "",
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full max-w-[1256px] px-2 mx-auto">
      <HomeDrawers />
      {syncData?.allow_donation &&
        <div className="px-3 my-4 sm:mb-10 xs:mb-5 mb-5">
          <HomeDonationBanner donations_count={syncData?.donations_count} />
        </div>
      }
      {user.isLoggedIn && syncData?.app_settings.active_order_tracker ? <ActiveOrder /> : null}
      {data?.items.map((item, index) => {
        let hasLcp=false;
        if (index < 2){
          // the LCP is in the first two items
          // if the first item is a slider or mainBanner then it has the LCP
          // if the second item is a slider or mainBanner and the first item is not a slider or mainBanner the it has the LCP
          // other than that assume the first item has the LCP
          if (item.type === "slider"){
            if (index === 0){
              hasLcp = true;
            } else if (!["slider", "mainBanner"].includes(data.items[0].type)){
              hasLcp = true;
            }
          } else if (item.type === "mainBanner"){
            if (index === 0){
              hasLcp = true;
            } else if (!["slider", "mainBanner"].includes(data.items[0].type)){
              hasLcp = true;
            }
          } else if ( !["slider", "mainBanner"].includes(data.items[0].type) && !["slider", "mainBanner"].includes(data.items[1].type)){
            if (index === 0) hasLcp = true;
          }
        }

        return (
        <div
          key={`home-${item.e?.v ?? item.items[0]?.id}`}
          className="sm:mb-10 xs:mb-5 mb-5"
        >
          {item.type === "slider" && (
            <div className="mt-10 mb-16">
              <Carousel data={item} sourceEntity={data.entity} hasLcp={hasLcp} />
            </div>
          )}
          {item.type === "video_sku" && (
            <div>
              <VideoList data={item} sourceEntity={data.entity} hasLcp={hasLcp} />
            </div>
          )}
          {item.type == "category" && (
            <div >
              <Categories data={item} sectionEntity={data.entity} hasLcp={hasLcp} />
            </div>
          )}
          {item.type === "product" && (
            <div>
              <CollectionList data={item} sourceEntity={data.entity} hasLcp={hasLcp} />
            </div>
          )}
          {item.type === "widget" && (
            <div>
              <Widget data={item} sourceEntity={data.entity} hasLcp={hasLcp} />
            </div>
          )}
          {item.type === "brand" && (
            <div>
              <Brand data={item} sectionEntity={data.entity} hasLcp={hasLcp} />
            </div>
          )}
          {item.type === "mainBanner" && (
            <div>
              <MainBanner
                data={item}
                sourceEntity={data.entity}
                hasLcp={hasLcp}
              />
            </div>
          )}
        </div>
      )})}
    </div>
  );
};

export default Home;